<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icons/Outline/chevron-right">
<path id="Vector" d="M7.5 15L12.5 10L7.5 5" stroke="#9FAEC4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
